import { UnicodeEntity } from '@mews/enums';
import { WithProfileId, isIntegrationProfileData } from '@mews-commander/types';
import { MessageThread } from '@mews-commander/messages';
import ViaIntegration from '../ViaIntegration';
import { useProfileData } from '../../useProfileData';

type ThreadSubjectProps = Pick<MessageThread, 'subject'> & WithProfileId;

const ThreadSubject = ({ subject, profileId }: ThreadSubjectProps) => {
    const profileData = useProfileData(profileId);

    if (!profileData) {
        return null;
    }

    const integrationProfileSubjectAdditions = isIntegrationProfileData(profileData) ? (
        <>
            {UnicodeEntity.NoBreakSpace}
            <ViaIntegration integrationId={profileData.value.integrationId} />
        </>
    ) : null;

    return (
        <>
            {subject}
            {integrationProfileSubjectAdditions}
        </>
    );
};

export default ThreadSubject;
